module.exports = __webpack_public_path__ + "static/img/salfimg.3b78a12f.png";